import React from "react";
import image from "../../../../assets/images/profile-pic.png";
import { useSessionStorage } from "../../../../hooks";

type DeveloperHeaderProps = {
  title: string;
};

const DeveloperHeader: React.FC<DeveloperHeaderProps> = ({ title }) => {
  const [user] = useSessionStorage("user", {});

  return (
    <>
      <div className="dev-head">
        <h4>{title}</h4>
        <div className="flex gap-2 items-center">
          <img
            src={image}
            alt={"Avatar"}
            style={{ objectFit: "cover" }}
            height={50}
            width={50}
            className="rounded-circle"
          />
          <div className="d-none d-md-block">
            <h6 className="capitalize">
              {user?.firstname.toLowerCase()}&nbsp;
              {user?.lastname.toLowerCase()}
            </h6>
            <p>{user?.email}</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default DeveloperHeader;
